import { initializeApp } from 'firebase/app';
import { getAuth, browserLocalPersistence, setPersistence } from 'firebase/auth';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
};

if (!firebaseConfig.apiKey || !firebaseConfig.authDomain || !firebaseConfig.projectId) {
  throw new Error('Missing Firebase environment configuration for EstateMate.');
}

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// Persist auth state to IndexedDB so sessions survive refresh and tab close
setPersistence(auth, browserLocalPersistence);

export { auth };
